import { render, staticRenderFns } from "./VPlanningView.vue?vue&type=template&id=2bf1085a&"
import script from "./VPlanningView.vue?vue&type=script&lang=js&"
export * from "./VPlanningView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports